export default "__VITE_ASSET__840e186a__"